export default __webpack_public_path__ + "static/media/food-menu3.c035ad43.jpeg";